import ActiveService from "rapid/service.active";

export class ToastService extends ActiveService {
    /**
     *
     * @param $injector
     */
    constructor($injector, $mdToast) {
        "ngInject";
        super($injector);
        this.$mdToast = $mdToast;
    }

    showSimple(text, hideIn) {
        this.$mdToast.show(
            this.$mdToast.simple().position("bottom right").hideDelay(hideIn)
                .textContent(text)
        );
    }

    showError(text, hideIn, position = "bottom right") {
        this.$mdToast.show(
            this.$mdToast.simple().position(position).hideDelay(hideIn).toastClass("error")
                .textContent(text)
        );
    }

    deleteToast(text, callback) {
        var toast = this.$mdToast.simple()
            .textContent(text)
            .action("UNDO")
            .position("bottom right")
            .hideDelay(15000);

        this.$mdToast.show(toast)
            .then(function(response) {
                if (response === "ok") {
                    callback();
                } else {
                    console.log("Toast dismissed.");
                }
            }).catch(function(err) {
            console.log(err);
        });
    }
}



// WEBPACK FOOTER //
// ./sources/services/toast.js